import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { HEADER_HEIGHT, MAIN_THEME } from '@styles';
import GenericDrawerHeaderContainer from './GenericDrawerHeaderContainer';

interface IGenericDrawerHeaderProps {
  background: string;
  title: string;
  onClose?: () => void;
}

const useStyles = makeStyles()(() => ({
  header: {
    justifyContent: 'space-between !important',
  },
  title: {
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '19px',
    margin: '0',
    fontWeight: 'bold',
  },
  close: {
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '19px',
    margin: '0 30px 0 0',
    background: 'unset',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
}));

const GenericDrawerHeader: React.FC<IGenericDrawerHeaderProps> = ({
  background,
  title,
  onClose,
}) => {
  const { classes } = useStyles();
  return (
    <GenericDrawerHeaderContainer
      className={classes.header}
      height={HEADER_HEIGHT}
      background={background}
    >
      <figure
        style={{
          height: '20px',
          width: '20px',
          margin: '0px 0 0 30px',
          background:
            "url('https://ufa-cdn.baibars.club/ufa-app-portal/images/app-launcher.svg')",
          backgroundSize: '20px 20px',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <span className={classes.title}>{title}</span>
      <button className={classes.close} type="button" onClick={onClose}>
        X
      </button>
    </GenericDrawerHeaderContainer>
  );
};

export default GenericDrawerHeader;
